import { render, staticRenderFns } from "./SocialTab.vue?vue&type=template&id=a253edca&scoped=true"
import script from "./SocialTab.vue?vue&type=script&lang=js"
export * from "./SocialTab.vue?vue&type=script&lang=js"
import style0 from "./SocialTab.vue?vue&type=style&index=0&id=a253edca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a253edca",
  null
  
)

export default component.exports